import { call, put, takeEvery, fork } from 'redux-saga/effects'

import {
    GET_LEADER_REQUESTED,
    GET_DEPARTMENTS_REQUESTED,
    GET_CASHBOX_REQUESTED,
    ADD_CASHBOX_REQUESTED,
    GET_EMPLOYEES_REQUESTED,
    GET_DEPARTMENTLEADER_REQUESTED,
    GET_CHIEFACCOUNTANT_REQUESTED,
    GET_ACCOUNTANT_REQUESTED,
    GET_SENIORCOMMODITYEXPERT_REQUESTED,
    GET_GOODSSPECIALIST_REQUESTED,
    GET_EMPLOYEE_REQUESTED,
    GET_REASONS_REQUESTED,
    ADD_BRANCH_REQUESTED,
    GET_BRANCHES_REQUESTED,
    CHANGE_BRANCH_REQUESTED,
    DELETE_BRANCH_REQUESTED, GET_AD_IMAGE_REQUESTED, DELETE_AD_IMAGE_REQUESTED, GET_DEPARTMENTS_TAB,
} from '../actions/actionTypes'
import {
    getLeaderSuccess,
    getDepartmentsSuccess,
    pageFailed,
    returnFailed,
    getCashboxSuccess,
    getCashboxFailed,
    addCashboxSuccess,
    addCashboxFailed,
    getDepartmentLeaderSuccess,
    getDepartmentLeaderFailed,
    getChiefAccountantSuccess,
    getChiefAccountantFailed,
    getAccountantSuccess,
    getAccountantFailed,
    getSeniorCommodityExpertSuccess,
    getSeniorCommodityExpertFailed,
    getGoodsSpecialistSuccess,
    getGoodsSpecialistFailed,
    getEmployeeSuccess,
    getEmployeeFailed,
    getReasonsSuccess,
    getReasonsFailed,
    addBranchSuccess,
    getBranchesSuccess,
    changeBranchSuccess,
    deleteBranchSuccess,
    adImageSuccess,
    deleteAdImageSuccess,
    getAdImageSuccess,
    returnFailedAdImage,
    getDepartmentTabSuccess,
} from '../actions/handbookAction'
import { messages } from '../../helpers/messages'
import { cashBoxService } from '../../services/cashbox-service'
import { userService } from '../../services/user-service'
import { reportService } from "../../services/report-service";
import { viewReports } from "../../helpers/data-constants";
import { getPrintedForm, getPrintedFormSuccess } from "../actions/contractAction";
import { permissionsAccess } from "../../helpers/common";

const getDepartmentsTab = async (payload) =>
    await cashBoxService.getDepartmentsTab(payload)
        .then(data => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })


const postBranch = async (data) => await cashBoxService
    .createBranch(data)
    .then(({ data: { branch } }) => branch)
    .catch(error => {
        if (error.response && (error.response.status >= 400 && error.response.status <= 500)) {
            let errorData = error.response.data
            let commonError = messages["0"]
            if (errorData.errorCode) {
                commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
        }
    })

const getBranches = async (size, page) => {
    return await cashBoxService.getBranches({ size, page, sortBy: "name" })
        .then(({ data }) => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })
}

const putBranch = async (data, id) => await cashBoxService
    .putBranch(data, id)
    .then(({ data: { branch } }) => branch)
    .catch(error => {
        if (error.response && (error.response.status >= 400 && error.response.status <= 500)) {
            let errorData = error.response.data
            let commonError = messages["0"]
            if (errorData.errorCode) {
                commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
        }
    })

const deleteBranch = async (id) => {
    return await cashBoxService
        .deleteBranch(id)
        .then(({ data }) => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })
}

const getAdImage = async (branchId) => {
    return await reportService.getAdImage(branchId)
        .then(({ data }) => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })
}

const adImage = async (payload) => {
    return await reportService.adImage(payload.name, payload.branchId, payload.advertImage.slice(23))
        .then(({ data }) => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })
}
const deleteAdImage = async (branchId) => {
    return await reportService.deleteAdImage(branchId)
        .then(({ data }) => data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })
}
const getUsers = async (payload) => await userService.getUsers(payload)
    .then(({ data: { users } }) => users)
    .catch(error => {
        if (error.response) {
            let errorData = error.response.data
            let commonError = messages["0"]
            if (errorData.errorCode) {
                commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
        }
    })

const getDepartments = async (payload) =>
    await cashBoxService.typeaheadCashBox(payload.bySearch, payload.access, payload.isMain)
        .then(({ data: { cashBoxes } }) => cashBoxes.map(u => ({ value: u.id, label: u.name })))
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })

const getCashbox = async (id, active, type) => {
    return await cashBoxService
        .getCashBox(id, active, type)
        .then(({ data }) => data.cashBox)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })
}

const addCashbox = async (data) => {
    return await cashBoxService
        .createCashBox(data)
        .catch(error => {
            if (error.response) {
                let errorData = error.response.data
                let commonError = messages["0"]
                if (errorData.errorCode) {
                    commonError = messages[errorData.errorCode]
                }
                window.scrollTo(0, 0)
                throw commonError
            }
        })
}

function* fetchDepartmentsTab({payload}) {
    try {
        const departments = yield call(() => getDepartmentsTab(payload))
        yield put(getDepartmentTabSuccess(departments))
    } catch (error) {
        yield put(pageFailed(error))
    }
}


const getTypeaheadUser = async (bySearch, document = false, active = 'active=true') => await userService.typeaheadUsers(bySearch, document, active)
    .then(({ data: { users } }) => users)
    .catch(error => {
        if (error.response) {
            let errorData = error.response.data
            let commonError = messages["0"]
            if (errorData.errorCode) {
                commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
        }
    })

const getReasons = async (value, type) => await cashBoxService
    .getReasons(value, type)
    .then(({ data }) => data.reasons.sort((a, b) => {
      return a.name.localeCompare(b.name, undefined, {sensitivity: 'base'});
    }))
    .catch(error => {
        if (error.response) {
            let errorData = error.response.data
            let commonError = messages["0"]
            if (errorData.errorCode) {
                commonError = messages[errorData.errorCode]
            }
            window.scrollTo(0, 0)
            throw commonError
        }
    })

function* fetchAddBranch({ payload }) {
    try {
        yield call(() => postBranch(payload.data))
        const branches = yield call(() => getBranches(payload.size, payload.page))
        yield put(addBranchSuccess(branches))
    } catch (error) {
        yield put(returnFailed(error))
    }
}
function* fetchGetBranches(action) {
    try {
        const branches = yield call(() => getBranches(action.size, action.page))
        yield put(getBranchesSuccess(branches))
    } catch (error) {
        yield put(pageFailed(error))
    }
}

function* fetchChangeBranch({ payload }) {
    try {
        if (payload.reportAdvert) {
            if (!!payload.image.name) {
                const advertImage = yield permissionsAccess("action.advert.add") && call(() => adImage(payload.image))
                yield permissionsAccess("action.advert.add") && put(adImageSuccess(advertImage))
            } else {
                yield permissionsAccess("action.advert.delete") && call(() => deleteAdImage(payload.branchId))
                yield permissionsAccess("action.advert.delete") && put(deleteAdImageSuccess())
            }
        }
        if (payload.editAccess){ yield call(() => putBranch(payload.data, payload.branchId))
            const branches = yield call(() => getBranches(payload.size, payload.page))
            yield put(changeBranchSuccess(branches))}
        if (payload.reportAdvert){
            yield put(getPrintedForm(payload.dataPrint, 'EmptyDeal', viewReports.PRINTED_DEAL))
            yield put(getPrintedFormSuccess(''))
        }
    } catch (error) {
        yield put(returnFailed(error))
    }
}

function* fetchDeleteBranch({ payload }) {
    try {
        yield call(() => deleteBranch(payload.id))
        const branches = yield call(() => getBranches(payload.size, payload.page))
        yield put(deleteBranchSuccess(branches))
    } catch (error) {
        yield put(pageFailed(error))
    }
}

function* fetchGetAdImage({branchId}) {
    try {
        const adImage = yield call(() => getAdImage(branchId))
        yield put(getAdImageSuccess(adImage))
    } catch (error) {
        yield put(returnFailedAdImage(error))
    }
}

function* fetchDeleteAdImage({branchId}) {
    try {
        yield call(() => deleteAdImage(branchId))
        yield put(deleteAdImageSuccess())
    } catch (error) {
        yield put(returnFailedAdImage(error))
    }
}

function* fetchLeaderUsers({ payload }) {
    try {
        const users = yield call(() => getUsers(payload))
        yield put(getLeaderSuccess(users))
    } catch (error) {
        yield put(pageFailed(error))
    }
}

function* fetchGetDepartments({ payload }) {
    try {
        const departments = yield call(() => getDepartments(payload))
        yield put(getDepartmentsSuccess(departments))
    } catch (error) {
        yield put(pageFailed(error))
    }
}

function* fetchGetCashbox(action) {
    try {
        const {id, active, type} = action.payload
        const cashbox = yield call(() => getCashbox(id, active, type))
        yield put(getCashboxSuccess(cashbox))
    } catch (error) {
        yield put(getCashboxFailed(error))
    }
}

function* fetchAddCashbox({ payload }) {
    try {
        const cashbox = yield call(() => addCashbox(payload))
        yield put(addCashboxSuccess(cashbox))
    } catch (error) {
        yield put(addCashboxFailed(error))
    }
}

function* fetchGetDepartmentLeader({ payload }) {
    try {
        const users = yield call(() => getTypeaheadUser(payload))
        yield put(getDepartmentLeaderSuccess(users))
    } catch (error) {
        yield put(getDepartmentLeaderFailed(error))
    }
}

function* fetchGetChiefAccountant({ payload }) {
    try {
        const users = yield call(() => getTypeaheadUser(payload))
        yield put(getChiefAccountantSuccess(users))
    } catch (error) {
        yield put(getChiefAccountantFailed(error))
    }
}

function* fetchGetAccountant({ payload }) {
    try {
        const users = yield call(() => getTypeaheadUser(payload))
        yield put(getAccountantSuccess(users))
    } catch (error) {
        yield put(getAccountantFailed(error))
    }
}

function* fetchGetSeniorCommodityExpert({ payload }) {
    try {
        const users = yield call(() => getTypeaheadUser(payload))
        yield put(getSeniorCommodityExpertSuccess(users))
    } catch (error) {
        yield put(getSeniorCommodityExpertFailed(error))
    }
}

function* fetchGetGoodsSpecialist({ payload }) {
    try {
        const users = yield call(() => getTypeaheadUser(payload))
        yield put(getGoodsSpecialistSuccess(users))
    } catch (error) {
        yield put(getGoodsSpecialistFailed(error))
    }
}

function* fetchGetEmployees(payload) {
    yield fork(fetchGetDepartmentLeader, payload)
    yield fork(fetchGetChiefAccountant, payload)
    yield fork(fetchGetAccountant, payload)
    yield fork(fetchGetSeniorCommodityExpert, payload)
    yield fork(fetchGetGoodsSpecialist, payload)
}

function* fetchGetEmployee({ payload }) {
    try {
        const users = yield call(getTypeaheadUser, payload.bySearch, payload.document, payload.active)
        yield put(getEmployeeSuccess(users))
    } catch (error) {
        yield put(getEmployeeFailed(error))
    }
}

function* fetchGetReasons({ payload }) {
    try {
        const reasons = yield call(getReasons, payload.value, payload.type)
        yield put(getReasonsSuccess(reasons))
    } catch (error) {
        yield put(getReasonsFailed(error))
    }
}

function* getDepartmentsTabSaga() {
    yield takeEvery(GET_DEPARTMENTS_TAB, fetchDepartmentsTab)
}


function* addBranchSaga() {
    yield takeEvery(ADD_BRANCH_REQUESTED, fetchAddBranch)
}

function* getBranchesSaga() {
    yield takeEvery(GET_BRANCHES_REQUESTED, fetchGetBranches)
}

function* changeBranchSaga() {
    yield takeEvery(CHANGE_BRANCH_REQUESTED, fetchChangeBranch)
}

function* deleteBranchSaga() {
    yield takeEvery(DELETE_BRANCH_REQUESTED, fetchDeleteBranch)
}

function* getAdImageSaga() {
    yield takeEvery(GET_AD_IMAGE_REQUESTED, fetchGetAdImage)
}

function* deleteAdImageSaga() {
    yield takeEvery(DELETE_AD_IMAGE_REQUESTED, fetchDeleteAdImage)
}
function* getUsersSaga() {
    yield takeEvery(GET_LEADER_REQUESTED, fetchLeaderUsers)
}

function* getDepartmentsSaga() {
    yield takeEvery(GET_DEPARTMENTS_REQUESTED, fetchGetDepartments)
}

function* getCashboxSaga() {
    yield takeEvery(GET_CASHBOX_REQUESTED, fetchGetCashbox)
}

function* addCashboxSaga() {
    yield takeEvery(ADD_CASHBOX_REQUESTED, fetchAddCashbox)
}

function* getEmployeesSaga() {
    yield takeEvery(GET_EMPLOYEES_REQUESTED, fetchGetEmployees)
}

function* getDepartmentLeaderSaga() {
    yield takeEvery(GET_DEPARTMENTLEADER_REQUESTED, fetchGetDepartmentLeader)
}

function* getChiefAccountantSaga() {
    yield takeEvery(GET_CHIEFACCOUNTANT_REQUESTED, fetchGetChiefAccountant)
}

function* getAccountantSaga() {
    yield takeEvery(GET_ACCOUNTANT_REQUESTED, fetchGetAccountant)
}

function* getSeniorCommodityExpertSaga() {
    yield takeEvery(GET_SENIORCOMMODITYEXPERT_REQUESTED, fetchGetSeniorCommodityExpert)
}

function* getGoodsSpecialistSaga() {
    yield takeEvery(GET_GOODSSPECIALIST_REQUESTED, fetchGetGoodsSpecialist)
}

function* getEmployeeSaga() {
    yield takeEvery(GET_EMPLOYEE_REQUESTED, fetchGetEmployee)
}

function* getReasonsSaga() {
    yield takeEvery(GET_REASONS_REQUESTED, fetchGetReasons)
}

export {
    addBranchSaga,
    getBranchesSaga,
    changeBranchSaga,
    deleteBranchSaga,
    getUsersSaga,
    getDepartmentsSaga,
    getCashboxSaga,
    addCashboxSaga,
    getEmployeesSaga,
    getDepartmentLeaderSaga,
    getChiefAccountantSaga,
    getAccountantSaga,
    getSeniorCommodityExpertSaga,
    getGoodsSpecialistSaga,
    getEmployeeSaga,
    getReasonsSaga,
    getAdImageSaga,
    deleteAdImageSaga,
    getDepartmentsTabSaga
}